import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "next-i18next";

import { LinkButton } from "@/components/index";
import { BUTTON_COLOR, BUTTON_VARIANT } from "@/shared/components/Button/Button.constants";
import {
  MAP_LANDING_BOOKS_SET_ID_TO_CONFIG,
  idCategoryCOA,
  idCategoryCONFLICT,
  idCategoryRPRAC,
} from "@/utils/landing/landing.constants";
import { I18N_NAMESPACE } from "@/shared/utils/multilang/constants";

const rootMaterialHref = "https://ellenwhite.ourproshop.com/#Category";
export const mapTitleSharingMaterialHref = {
  "108": `${rootMaterialHref}3`, // Steps to Christ
  "150": `${rootMaterialHref}4`, // Thoughts From the Mount of Blessing
  "15": `${rootMaterialHref}5`, // Christ’s Object Lessons
  "135": `${rootMaterialHref}6`, // The Ministry of Healing
  "29": `${rootMaterialHref}7`, // Education
  "84": `${rootMaterialHref}8`, // Patriarchs and Prophets
  "88": `${rootMaterialHref}9`, // Prophets and Kings
  "130": `${rootMaterialHref}10`, // The Desire of Ages
  "127": `${rootMaterialHref}11`, // The Acts of the Apostles
  "132": `${rootMaterialHref}12`, // The Great Controversy
  [MAP_LANDING_BOOKS_SET_ID_TO_CONFIG[idCategoryCOA].title]: `${rootMaterialHref}14`, // The COA Series
  [MAP_LANDING_BOOKS_SET_ID_TO_CONFIG[idCategoryCONFLICT].title]: `${rootMaterialHref}18`, // The Conflict Series
  [MAP_LANDING_BOOKS_SET_ID_TO_CONFIG[idCategoryRPRAC].title]: `${rootMaterialHref}20`, // The Conflict Series
};

const ShareMaterials = ({
  buttonVariant = BUTTON_VARIANT.outline,
  buttonColor = BUTTON_COLOR.secondary,
  href,
}) => {
  const { t } = useTranslation();
  return (
    <LinkButton target="_blank" variant={buttonVariant} color={buttonColor} href={href}>
      {t(I18N_NAMESPACE.books + ":" + "sharingMaterials")}
    </LinkButton>
  );
};

ShareMaterials.propTypes = {
  buttonVariant: PropTypes.string,
  buttonColor: PropTypes.string,
  href: PropTypes.string,
};

export default ShareMaterials;
